import React, { createContext, useContext } from "react";
import { getData } from "./Api";

const data = {
  loading: false,
  error: false,
  data: [],
};

const homeReducer = (state, action) => {
  switch (action.type) {
    case "LOADING":
      return { ...state, loading: true, error: false };
    case "SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload,
      };
    case "ERROR":
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

const HomeContext = createContext();

export const HomeProvider = ({ children }) => {
  const [homeState, dispatch] = React.useReducer(homeReducer, data);

  const getHomeAssets = async () => {
    dispatch({ type: "LOADING" });
    try {
      const urlPath = `/images?type=home/`;
      await getData(urlPath).then((data) => {
        if (data?.type === "ERROR") { 
            return dispatch({
            type: "ERROR",
            payload: data.payload
        })}
        return dispatch({
          type: "SUCCESS",
          payload: data.payload?.urls
        });
      });
    } catch (error) {
      return dispatch({
        type: "ERROR",
        payload: error,
      });
    }
  };

  return (
    <HomeContext.Provider value={{ getHomeAssets, homeState }}>
      {children}
    </HomeContext.Provider>
  );
};

export const useHome = () => {
  const context = useContext(HomeContext);

  if (!context) {
    return new Error("Provider required");
  }
  return context;
};
